import { memo } from 'react';
import { Navigate } from 'react-router-dom';

import { hasReadableSession } from '../../utils/session';

import { PermissionProvider } from '../../context/permission.context';
import { AccountProvider } from '../../context/account.context';
import { useAccount } from '../../smallApps/users/hooks/useAccount';

interface Props {
  children: JSX.Element;
}

const PrivateRoute = ({ children }: Props) => {
  // Was `!!localStorage.getItem('token')` -- the presence of a string, not a
  // readable one. A corrupt token passed this guard and then crashed the page
  // it had just admitted the user to.
  const isAuthenticated = hasReadableSession();
  const { account } = useAccount();

  return (
    <>
      {isAuthenticated ? (
        <AccountProvider>
          <PermissionProvider role={account?.role}>
            {account?.role ? children : null}
          </PermissionProvider>
        </AccountProvider>
      ) : (
        <Navigate to={{ pathname: '/auth/login' }} replace />
      )}
    </>
  );
};

export default memo(PrivateRoute);
